export const FacilityGroupingDropTypesArray = [
  'FACILITY_FROM_LIST',
  'FACILITY_FROM_HIERARCHY',
  'FACILITY_GROUP'
] as const;
export type FacilityGroupingDropTypes =
  typeof FacilityGroupingDropTypesArray[number];
